module.exports = __webpack_public_path__ + "web_static/img/intro_card.622294ad.gif";